export default {
  faqDocUrl:
    'https://s3.amazonaws.com/farmers-qa-host/docs/chubb/p360/common/marketing/chubb_p360_faq.pdf',
  planOverviewUrl:
    'https://s3.amazonaws.com/farmers-qa-host/docs/chubb/p360/common/marketing/chubb_p360_brochure.pdf',
  eaServicesUrl:
    'https://farmers-qa-host.s3.amazonaws.com/docs/chubb/p360/common/marketing/chubb_p360_ea_services_2020.pdf',
};
